import { currentDataset, lang, g_listOrigin } from "../core/variables-global.js";
import { config } from "../core/config.js";
import { simpleSearchRadioLabels, simpleSearchLabels } from "../core/l10n.js";
import UIHelper from "../utils/UIHelper.js";
import validationForm from "../utils/validation.js";

function initSimpleSearch() {
  const moduleSearchSimple = document.querySelector('.js-recherche-simple');

  if (!moduleSearchSimple) return;
  const searchInput = moduleSearchSimple.querySelector('.js-search-input');
  const searchButton = moduleSearchSimple.querySelector('.js-search-button');
  const statusMessage = moduleSearchSimple.querySelector('.js-status-message');
  const resultsContainer = moduleSearchSimple.querySelector('.js-results-container');
  const reloadButton = moduleSearchSimple.querySelector('.js-reload');
  const radioNumberType = moduleSearchSimple.querySelectorAll('.js-radio-input');
  const numberTypeText = moduleSearchSimple.querySelector('.js-text-number');

  function handleSearchAction(e) {
    console.log("Lancement de la recherche simple...", currentDataset);
    e.preventDefault();
    ga4DataLayerPush(e.target);
    performSearch(e);

    hideSearchCriterias();
  }

  function hideSearchCriterias() {
    document.querySelector(".js-module-resultats-recherche").innerHTML = "";

    const accordeonButton = document.querySelector("#accordeon-777-bouton-0");
    const accordeonTiroir = document.querySelector("#accordeon-777-tiroir-0");

    if (accordeonButton && accordeonTiroir && accordeonButton.getAttribute("aria-expanded") === "true") {
      accordeonButton.setAttribute("aria-expanded", "false");
      accordeonTiroir.setAttribute("hidden", "true");
      accordeonTiroir.style.maxHeight = "0px";
      accordeonTiroir.style.display = "none";

      const accordeon = accordeonButton.closest(".js-accordeons");
      if (accordeon) {
        accordeon.classList.remove("background", "open");
      }
    }
  }

  function handleResetAction(e) {
    e.preventDefault();
    resetSearch();
  }

  function isEnterKey(e) {
    return e.key === "Enter" || e.keyCode === 13;
  }

  searchButton.addEventListener("click", handleSearchAction);
  searchInput.addEventListener("keydown", (e) => isEnterKey(e) && handleSearchAction(e));
  reloadButton.addEventListener("click", handleResetAction);
  reloadButton.addEventListener("keydown", (e) => isEnterKey(e) && handleResetAction(e));

  function ga4DataLayerPush(target) {
    let clickedElemVal = target.textContent.trim().replace(/\s+/g, ' ');

    let ga4Element = {
      element_label: clickedElemVal,
      step_nb: "2",
      step_name: "Recherche ahri"
    };

    if (window.initTrackingGA4) {
      window.initTrackingGA4.sendDataToGA4(ga4Element);
    }
  }

  function resetSearch() {
    if (resultsContainer) {
      resultsContainer.innerHTML = "";
    }

    if (statusMessage) {
      statusMessage.innerHTML = "";
      statusMessage.className = "status-message js-status-message";
    }

    if (searchInput) {
      searchInput.value = "";
      searchInput.focus();
    }

    searchInput && searchInput.classList.remove("error");
  }

  function preloadData(e) {
    console.log("Préchargement des données pour la recherche simple...");
    //UIHelper.showGlobalLoading(true);
    statusMessage.textContent = "";
    statusMessage.className = "status-message js-status-message";

    window.dataExchange.loadData()
      .then(() => {
        statusMessage.textContent = "";
       })
      .catch(error => {
        const message = {
          title: `Erreur de chargement des données. Veuillez réessayer plus tard.`,
          error: error.message
        }
        UIHelper.displayBandeauErrorMessage({message});
        //UIHelper.displayErrorMessage(`Erreur de chargement: ${error.message}`, statusMessage);
      })
      .finally(() => {
        if (!config.fromURLParam) {
          showLoading(false);
          UIHelper.showGlobalLoading(false);
        }
        window.initAccordeon();
      })
      if (e && e.target) {
        numberTypeText.textContent = (e.target.value === 'ahri') ? simpleSearchRadioLabels.label[lang].ahri : simpleSearchRadioLabels.label[lang].energystar;
      }
  }
  function loadSelectedData() {
    preloadData();
  }

  const searchInIndexData = async (searchTerm, field) => {
    const output = window.dataExchange.indexData(window.currentData, field);
    console.log("Indexed data search", output);
    return output.get(searchTerm) ? [output.get(searchTerm)] : [];
  }

  const performSearch = async () => {
    showLoading(true);
    UIHelper.showGlobalLoading(true, simpleSearchLabels.loading.label[lang]);

    resultsContainer.innerHTML = "";
    statusMessage.innerHTML = "";
    statusMessage.className = "status-message js-status-message";
    searchInput && searchInput.classList.remove("error");

    const isEnergyStar = (window.searchBy === "energystar") ? true : false;
    // Validation selon le type de numéro sélectionné
    const isValid = isEnergyStar
      ? validationForm.inputLength(searchInput, 7, 7)
      : validationForm.inputLength(searchInput, 6, 12);

    if (!isValid.isValid) {
      UIHelper.displayErrorMessage(isValid.message);
      searchInput && searchInput.classList.add("error");

      showLoading(false);
      UIHelper.showGlobalLoading(false);

      return Promise.resolve(); // Retourner une promesse résolue
    }

    const searchTerm = searchInput.value.trim();

    try {
      // In indexedDB
      //const output = (isEnergyStar) ? await window.IndexedDBManager.searchByIdES(searchTerm, dataset) : await window.IndexedDBManager.searchByAHRI(searchTerm, dataset);

      //In memory indexed data
      const field = (g_listOrigin ==="es") ? (window.searchBy === "energystar") ? "pd_id" : "ahri_reference_number" : "ahri";

      const output = await searchInIndexData(searchTerm, field)

      window.initAccordeon();

     window.simpleSearchResult.displayResult(output[0], resultsContainer, lang);
      console.log("Résultat de la recherche simple:", output, resultsContainer, lang);
    } catch (error) {
        UIHelper.displayErrorMessage(`Aucune thermopompe ne correspond à ce numéro`);
        searchInput && searchInput.classList.add("error");
        showLoading(false);
        UIHelper.showGlobalLoading(false);
    }
    //Reste afficher minimum 1 sec le loader
    setTimeout(() => {
      showLoading(false);
      UIHelper.showGlobalLoading(false);
    }, 1000);

    return Promise.resolve();
  }

  const watchRadioChanges = () =>{
    radioNumberType.forEach(radio => {
      radio.addEventListener('change', (e) => {
        searchInput.value = '';
        resetSearch();
        const messageErreur = statusMessage.querySelector('.message-erreur');

        if (searchInput.classList.contains('error') && statusMessage.classList.contains('error')) {
          if (messageErreur) {
            messageErreur.remove();
          }
          searchInput.classList.remove('error');
          statusMessage.classList.remove('error');
        }

        window.searchBy = e.target.value;

        numberTypeText.textContent = (e.target.value === 'ahri') ? simpleSearchRadioLabels.label[lang].ahri : simpleSearchRadioLabels.label[lang].energystar;

      });
    });
  }

  watchRadioChanges();

  function showLoading(show) {
     const elements = [searchInput, searchButton, reloadButton];
    UIHelper.setElementsDisabled(elements, show);
  }

  initSimpleSearch.loadSelectedData = loadSelectedData;

  return {
    loadSelectedData,
    resetSearch,
    searchInput,searchButton, reloadButton
  };
};

window.initSimpleSearch = initSimpleSearch();
export default window.initSimpleSearch;
